import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, Button } from '../../components/ui';
import { PageHeader } from '@/components/layout/PageHeader';
import { adminBackofficeApi } from '../../services/adminBackoffice';
import type { MarketingCampaign } from '@court-sync/shared';

export default function CampaignsPage() {
  const [campaigns, setCampaigns] = useState<MarketingCampaign[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminBackofficeApi
      .getCampaigns({ limit: 50 })
      .then((res) => {
        if (res.success) setCampaigns(res.data.campaigns || []);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-6 space-y-6">
      <PageHeader
        title="Marketing Campaigns"
        help={<p>Send news articles to opted-in users and prospects via Mailjet.</p>}
        actions={
          <Link to="/backoffice/campaigns/new">
            <Button>New campaign</Button>
          </Link>
        }
      />

      <Card>
        <CardContent className="pt-6">
          {loading ? (
            <p>Loading...</p>
          ) : campaigns.length === 0 ? (
            <p className="text-muted-foreground">No campaigns yet.</p>
          ) : (
            <ul className="divide-y">
              {campaigns.map((c) => (
                <li key={c.id} className="py-3 flex items-center justify-between">
                  <div>
                    <p className="font-medium">{c.subject}</p>
                    <p className="text-sm text-muted-foreground">
                      {c.status} · {c.sentCount}/{c.recipientsCount} sent
                    </p>
                  </div>
                  <Link to={`/backoffice/campaigns/${c.id}`}>
                    <Button variant="outline" size="sm">
                      View
                    </Button>
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
